import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeSeasonSetsListData } from "Pages/AutoEuropeTool/SeasonSets/@signals"

const SEASON_SETS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets`

export default function useAutoEuropeSeasonSetsActions() {
	const { showToast } = useToast()

	const onDelete = useCallback(async (id, name) => {
		let assignedCount = 0
		try {
			const tools = await fetch(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/list`).then(r => r.json())
			assignedCount = (tools || []).filter(t => t.seasonSetId === id).length
		} catch {
			// if the check fails, let the delete proceed (backend will guard)
		}

		if (assignedCount > 0) {
			showToast.error(
				`Cannot delete "${name}": ${assignedCount} pricing tool${assignedCount > 1 ? 's are' : ' is'} using this season set.`
			)
			return
		}

		showToast.confirm(`Are you sure you want to delete "${name}"? This action cannot be undone.`, {
			onSubmit: () => showToast.promise(
				postSubmit(`${SEASON_SETS_API}/delete`, { id }),
				{
					onSuccess: () => {
						autoEuropeSeasonSetsListData.value = autoEuropeSeasonSetsListData.value.filter(
							item => item.id !== id
						)
					},
				}
			)
		})
	}, [])

	return { onDelete }
}
